(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Collection Filters Functionality
  document.addEventListener('DOMContentLoaded', function () {
    const filterForm = document.querySelector('[data-collection-filters]');
    const sortInputs = document.querySelectorAll('input[name="sort_by"]');
    const sortOptions = document.querySelectorAll('.sort-option');
    const filterInputs = document.querySelectorAll('input[type="checkbox"]');

    // Handle sort option clicks
    sortOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const value = this.getAttribute('data-value');
        const input = document.querySelector(`input[name="sort_by"][value="${value}"]`);
        if (input) {
          input.checked = true;
          updateSortStyling();
          const url = new URL(window.location);
          url.searchParams.set('sort_by', value);
          window.location.href = url.toString();
        }
      });
    });

    // Handle filter changes
    filterInputs.forEach((input) => {
      input.addEventListener('change', function () {
        applyFilters();
      });
    });

    // Apply filters function
    function applyFilters() {
      const url = new URL(window.location);
      const formData = new FormData(filterForm);

      // Clear existing filter params
      const paramsToRemove = [];
      for (const [key] of url.searchParams) {
        if (key.startsWith('filter.')) {
          paramsToRemove.push(key);
        }
      }
      paramsToRemove.forEach((param) => url.searchParams.delete(param));

      // Add new filter params
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('filter.') && value) {
          url.searchParams.set(key, value);
        }
      }

      window.location.href = url.toString();
    }

    // Clear filters function
    window.clearFilters = function () {
      const url = new URL(window.location);
      const paramsToRemove = [];
      for (const [key] of url.searchParams) {
        if (key.startsWith('filter.') || key === 'sort_by') {
          paramsToRemove.push(key);
        }
      }
      paramsToRemove.forEach((param) => url.searchParams.delete(param));
      window.location.href = url.toString();
    };

    // Toggle mobile filters function
    window.toggleMobileFilters = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const mobileFilters = document.getElementById('mobile-filters');
      const toggleButton = document.getElementById('mobile-filter-toggle');

      if (mobileFilters && toggleButton) {
        if (mobileFilters.classList.contains('mobile-filters-hidden')) {
          // Show filters
          mobileFilters.classList.remove('mobile-filters-hidden');
          mobileFilters.classList.add('mobile-filters-visible');
          toggleButton.textContent = 'Hide filters';
        } else {
          // Hide filters
          mobileFilters.classList.remove('mobile-filters-visible');
          mobileFilters.classList.add('mobile-filters-hidden');
          toggleButton.textContent = 'Show filters';
        }
      }

      return false;
    };

    // Update sort option styling
    function updateSortStyling() {
      sortOptions.forEach((option) => {
        option.classList.remove('selected');
        const value = option.getAttribute('data-value');
        const input = document.querySelector(`input[name="sort_by"][value="${value}"]`);
        if (input && input.checked) {
          option.classList.add('selected');
        }
      });
    }

    // Set current sort value and styling
    const currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    const currentSortInput = document.querySelector(`input[name="sort_by"][value="${currentSort}"]`);
    if (currentSortInput) {
      currentSortInput.checked = true;
    }
    updateSortStyling();

    // Set current filter values
    const urlParams = new URLSearchParams(window.location.search);
    filterInputs.forEach((input) => {
      const paramName = input.name;
      const paramValue = input.value;
      if (urlParams.get(paramName) === paramValue) {
        input.checked = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Logo video hover behavior
    const logoVideo = document.querySelector('.logo-video');
    const logoContainer = document.querySelector('.logo-video-container');

    if (logoVideo && logoContainer) {
      // Only add source and enable video on desktop
      function isDesktop() {
        return window.innerWidth >= 768;
      }
      function isSafariBrowser() {
        var ua = navigator.userAgent || '';
        var vendor = navigator.vendor || '';
        var isAppleVendor = vendor.indexOf('Apple') > -1;
        var isSafariUA = /safari/i.test(ua) && !/chrome|crios|chromium|edg/i.test(ua);
        return isAppleVendor || isSafariUA;
      }

      var safari = isSafariBrowser();

      // On Safari desktop, hide video and show fallback image
      if (isDesktop() && safari) {
        logoVideo.style.display = 'none';
        const fallbackImage = logoContainer.querySelector('.logo-fallback-image');
        if (fallbackImage) {
          fallbackImage.style.setProperty('display', 'block', 'important');
        }
      } else if (isDesktop() && !logoVideo.querySelector('source')) {
        // Only load video source for non-Safari desktop browsers
        var webmSrc = logoVideo.dataset.videoSrcWebm;
        var movSrc = logoVideo.dataset.videoSrcMov;
        var chosenSrc = null;
        var chosenType = null;
        if (webmSrc) {
          chosenSrc = webmSrc;
          chosenType = 'video/webm; codecs=vp9, opus';
        } else if (movSrc) {
          chosenSrc = movSrc;
          chosenType = 'video/quicktime; codecs=hvc1';
        }
        if (chosenSrc) {
          const source = document.createElement('source');
          source.src = chosenSrc;
          if (chosenType) source.type = chosenType;
          logoVideo.appendChild(source);
          logoVideo.load();
        }
      }

      // Ensure video is paused initially
      logoVideo.pause();

      // Play on hover (only for non-Safari desktop browsers)
      logoContainer.addEventListener('mouseenter', function () {
        if (isDesktop() && !safari && logoVideo.querySelector('source')) {
          logoVideo.play();
          logoVideo.classList.add('playing');
        }
      });

      // Pause when mouse leaves and go back to first frame (only for non-Safari desktop browsers)
      logoContainer.addEventListener('mouseleave', function () {
        if (isDesktop() && !safari && logoVideo.querySelector('source')) {
          logoVideo.pause();
          logoVideo.currentTime = 0;
          logoVideo.classList.remove('playing');
        }
      });
    }

    // Ticker bar scroll detection
    const tickerBar = document.querySelector('.ticker-bar');
    const header = document.querySelector('.header-overlay');

    if (tickerBar && header && header.classList.contains('header-with-ticker')) {
      let lastScrollY = window.scrollY;
      let ticking = false;

      function updateHeaderPosition() {
        const currentScrollY = window.scrollY;
        const tickerHeight = tickerBar.offsetHeight;

        // If scrolled past the ticker bar height, hide the ticker positioning
        if (currentScrollY > tickerHeight) {
          header.classList.add('ticker-hidden');
          document.body.classList.add('ticker-hidden');
        } else {
          header.classList.remove('ticker-hidden');
          document.body.classList.remove('ticker-hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      }

      function requestTick() {
        if (!ticking) {
          requestAnimationFrame(updateHeaderPosition);
          ticking = true;
        }
      }

      // Listen for scroll events
      window.addEventListener('scroll', requestTick, { passive: true });

      // Initial check
      updateHeaderPosition();
    }

    // Dropdown functionality
    const dropdowns = document.querySelectorAll('[data-dropdown]');

    dropdowns.forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.dropdown-trigger');
      const content = dropdown.querySelector('.dropdown-content');

      if (!trigger || !content) return;

      // Toggle dropdown
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = dropdown.getAttribute('data-open') === 'true';

        // Close all other dropdowns first
        document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
          if (otherDropdown !== dropdown) {
            otherDropdown.setAttribute('data-open', 'false');
            otherDropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current dropdown
        if (isOpen) {
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
          // Remove mobile dropdown class from header
          if (
            dropdown.getAttribute('data-dropdown') === 'mobile-shop-dropdown' ||
            dropdown.getAttribute('data-dropdown') === 'mobile-cart-dropdown'
          ) {
            document.querySelector('.header-overlay').classList.remove('mobile-dropdown-open');
          }
        } else {
          dropdown.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
          // Only prevent body scroll for mobile dropdown
          if (
            dropdown.getAttribute('data-dropdown') === 'mobile-shop-dropdown' ||
            dropdown.getAttribute('data-dropdown') === 'mobile-cart-dropdown'
          ) {
            document.body.style.overflow = 'hidden';
            document.querySelector('.header-overlay').classList.add('mobile-dropdown-open');
          }
        }
      });

      // Close dropdown when clicking outside (only for desktop dropdowns)
      if (
        dropdown.getAttribute('data-dropdown') === 'shop-dropdown' ||
        dropdown.getAttribute('data-dropdown') === 'cart-dropdown'
      ) {
        document.addEventListener('click', function (e) {
          if (!dropdown.contains(e.target)) {
            dropdown.setAttribute('data-open', 'false');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      // Close dropdown on escape key (only for mobile dropdowns)
      if (
        dropdown.getAttribute('data-dropdown') === 'mobile-shop-dropdown' ||
        dropdown.getAttribute('data-dropdown') === 'mobile-cart-dropdown'
      ) {
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && dropdown.getAttribute('data-open') === 'true') {
            dropdown.setAttribute('data-open', 'false');
            trigger.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
            document.querySelector('.header-overlay').classList.remove('mobile-dropdown-open');
          }
        });
      }

      // Open dropdown on hover (for desktop shop dropdown and cart dropdown only)
      if (
        dropdown.getAttribute('data-dropdown') === 'shop-dropdown' ||
        dropdown.getAttribute('data-dropdown') === 'cart-dropdown'
      ) {
        dropdown.addEventListener('mouseenter', function () {
          // Close all other dropdowns first
          document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
            if (otherDropdown !== dropdown) {
              otherDropdown.setAttribute('data-open', 'false');
              otherDropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
              document.body.style.overflow = '';
              // Remove mobile dropdown class from header
              if (otherDropdown.getAttribute('data-dropdown') === 'mobile-shop-dropdown') {
                document.querySelector('.header-overlay').classList.remove('mobile-dropdown-open');
              }
            }
          });

          // Open current dropdown
          dropdown.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
        });

        // Close dropdown when mouse leaves
        dropdown.addEventListener('mouseleave', function (e) {
          const relatedTarget = e.relatedTarget;
          // Only close if mouse is leaving the entire dropdown container
          // and not moving to a child element
          if (!dropdown.contains(relatedTarget)) {
            dropdown.setAttribute('data-open', 'false');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });

  // Cart remove function - moved here for global availability
  function removeCartItem(itemKey) {
    // First, get the current cart to check for bundle relationships
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        // Find the item being removed
        const itemToRemove = cart.items.find((item) => item.key === itemKey);

        if (itemToRemove && itemToRemove.properties && itemToRemove.properties['Bundle Group']) {
          // This is a bundle item - remove all items in the same bundle
          const bundleId = itemToRemove.properties['Bundle Group'];
          const itemsToRemove = cart.items
            .filter((item) => item.properties && item.properties['Bundle Group'] === bundleId)
            .map((item) => item.key);

          // Remove all items in the bundle
          return Promise.all(
            itemsToRemove.map((key) =>
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                  id: key,
                  quantity: 0,
                }),
              }).then((response) => response.json())
            )
          );
        } else {
          // Regular item - remove normally
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0,
            }),
          }).then((response) => response.json());
        }
      })
      .then(() => {
        // Update cart UI after successful removal
        window.updateCartUI();
        // Note: openCartDropdown is already called within updateCartUI
      })
      .catch((error) => {
        console.error('Error removing item from cart:', error);
      });
  }

  // Global cart update functionality - available on all pages
  window.updateCartUI = function () {
    console.log('updateCartUI called');
    // Fetch updated cart data
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        console.log('Cart data fetched:', cart);

        // Update cart count in header buttons
        const cartButtons = document.querySelectorAll('[data-cart-count]');
        console.log('Found', cartButtons.length, 'cart buttons to update');
        cartButtons.forEach((button) => {
          button.setAttribute('data-cart-count', cart.item_count);
        });

        // Update cart count in pill badges
        const cartPills = document.querySelectorAll('.btn__pill');
        console.log('Found', cartPills.length, 'cart pills to update');
        cartPills.forEach((pill) => {
          pill.textContent = cart.item_count;
        });

        // Update cart dropdown content if it's open
        const cartDropdown = document.querySelector('#cart-dropdown-content');
        const mobileCartDropdown = document.querySelector('#mobile-cart-dropdown-content');

        if (cartDropdown && cartDropdown.parentElement.getAttribute('data-open') === 'true') {
          console.log('Updating desktop cart dropdown');
          updateCartDropdownContent(cart);
        }
        if (mobileCartDropdown && mobileCartDropdown.parentElement.getAttribute('data-open') === 'true') {
          console.log('Updating mobile cart dropdown');
          updateCartDropdownContent(cart);
        }

        // Always update cart dropdown content regardless of open state
        console.log('Updating cart dropdown content regardless of open state');
        updateCartDropdownContent(cart);

        // Always update free shipping progress regardless of dropdown state
        console.log('Updating free shipping progress regardless of dropdown state');
        updateFreeShippingProgress(cart);

        // Open cart dropdown when cart is updated
        console.log('Opening cart dropdown after cart update');
        window.openCartDropdown();

        // Also try to update free shipping progress after a short delay to ensure elements are available
        setTimeout(() => {
          console.log('Delayed free shipping progress update');
          updateFreeShippingProgress(cart);
        }, 100);
      })
      .catch((error) => {
        console.error('Error updating cart UI:', error);
      });
  };

  // Global add to cart function - available on all pages
  window.addToCart = function (variantId, quantity = 1) {
    // Check if cart is currently empty before adding
    const currentCartCount = document.querySelector('[data-cart-count]')?.getAttribute('data-cart-count') || '0';
    const wasCartEmpty = parseInt(currentCartCount) === 0;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Product added to cart:', data);
        // Update cart UI after successful add
        window.updateCartUI();

        // If cart was empty and now has items, open the cart dropdown
        if (wasCartEmpty) {
          console.log('Cart was empty, opening cart dropdown');
          window.openCartDropdown();
        }

        // You can add success feedback here (e.g., show a toast notification)
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
        // You can add error feedback here
      });
  };

  // Function to open cart dropdown
  window.openCartDropdown = function () {
    // Try to open desktop cart dropdown first
    const desktopCartDropdown = document.querySelector('[data-dropdown="cart-dropdown"]');
    const mobileCartDropdown = document.querySelector('[data-dropdown="mobile-cart-dropdown"]');

    if (desktopCartDropdown) {
      // Close all other dropdowns first
      document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
        if (otherDropdown !== desktopCartDropdown) {
          otherDropdown.setAttribute('data-open', 'false');
          const otherTrigger = otherDropdown.querySelector('.dropdown-trigger');
          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Open desktop cart dropdown
      desktopCartDropdown.setAttribute('data-open', 'true');
      const desktopTrigger = desktopCartDropdown.querySelector('.dropdown-trigger');
      if (desktopTrigger) {
        desktopTrigger.setAttribute('aria-expanded', 'true');
      }
      console.log('Opened desktop cart dropdown');
    } else if (mobileCartDropdown) {
      // Close all other dropdowns first
      document.querySelectorAll('[data-dropdown]').forEach(function (otherDropdown) {
        if (otherDropdown !== mobileCartDropdown) {
          otherDropdown.setAttribute('data-open', 'false');
          const otherTrigger = otherDropdown.querySelector('.dropdown-trigger');
          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Open mobile cart dropdown
      mobileCartDropdown.setAttribute('data-open', 'true');
      const mobileTrigger = mobileCartDropdown.querySelector('.dropdown-trigger');
      if (mobileTrigger) {
        mobileTrigger.setAttribute('aria-expanded', 'true');
      }
      document.body.style.overflow = 'hidden';
      document.querySelector('.header-overlay').classList.add('mobile-dropdown-open');
      console.log('Opened mobile cart dropdown');
    } else {
      console.log('No cart dropdown found to open');
    }
  };

  // Function to update cart dropdown content
  function updateCartDropdownContent(cart) {
    // Update cart items section
    const cartItemsContainer = document.querySelector('#cart-dropdown-content .space-y-4');
    const mobileCartItemsContainer = document.querySelector('#mobile-cart-dropdown-content .space-y-4');

    if (cartItemsContainer) {
      updateCartItemsContainer(cartItemsContainer, cart);
    }
    if (mobileCartItemsContainer) {
      updateCartItemsContainer(mobileCartItemsContainer, cart);
    }

    // Update HR visibility based on cart state
    updateHrVisibility(cart);

    // Update cart summary
    updateCartSummary(cart);

    // Update free shipping progress
    updateFreeShippingProgress(cart);
  }

  // Function to update HR visibility
  function updateHrVisibility(cart) {
    const hrElements = document.querySelectorAll('#cart-dropdown-content hr, #mobile-cart-dropdown-content hr');

    // If no HR elements exist and cart has items, create them
    if (hrElements.length === 0 && cart.item_count > 0) {
      const cartDropdowns = document.querySelectorAll('#cart-dropdown-content, #mobile-cart-dropdown-content');
      cartDropdowns.forEach((dropdown) => {
        // Find the cart items container
        const itemsContainer = dropdown.querySelector('.space-y-4');
        if (itemsContainer) {
          // Create HR element after the items container
          const hrElement = document.createElement('hr');
          hrElement.className = 'border-brand-dark-2 mb-4';
          itemsContainer.parentNode.insertBefore(hrElement, itemsContainer.nextSibling);
          console.log('Created HR element in cart dropdown');
        }
      });
    }

    // Now update all HR elements
    const updatedHrElements = document.querySelectorAll('#cart-dropdown-content hr, #mobile-cart-dropdown-content hr');
    updatedHrElements.forEach((hr) => {
      if (cart.item_count > 0) {
        hr.style.display = 'block';
      } else {
        hr.style.display = 'none';
      }
    });
  }

  // Function to update cart items container
  function updateCartItemsContainer(container, cart) {
    if (cart.item_count > 0) {
      // Helper function to create item HTML
      const createItemHTML = (item, isChild = false) => {
        const indentClass = isChild ? 'ml-8 opacity-80' : '';
        return `
          <div class="bg-brand-dark-2 rounded-[10px] py-4 px-5 flex items-center gap-6 ${indentClass}">
            <div class="w-[49px] h-[61px] flex-shrink-0">
              ${
                item.image
                  ? `<img src="${item.image}" alt="${item.title}" width="49" height="61" class="w-full h-full object-cover rounded" loading="lazy">`
                  : `<div class="w-full h-full bg-gray-300 rounded flex items-center justify-center"><span class="text-gray-500 text-xs">No image</span></div>`
              }
            </div>
            <div class="flex-1 min-w-0">
              <p class="!text-[20px] truncate !m-0">
                ${item.product_title}
                ${item.quantity > 1 ? ` (${item.quantity})` : ''}
              </p>
              ${item.price > 0 ? `<p class="!text-[16px] opacity-50 !m-0">${formatMoney(item.price)}</p>` : ''}
            </div>
            <button
              type="button"
              class="w-[11px] h-[11px] flex items-center justify-center text-white hover:opacity-70 transition-opacity flex-shrink-0 cart-remove-btn"
              data-item-key="${item.key}"
              aria-label="Remove ${item.title} from cart"
            >
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L10 10M10 1L1 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        `;
      };

      // Helper function to check if item is build-a-drip
      const isBuildADripItem = (item) => {
        return (
          item.product_title.includes('Beads - Build A Drip') ||
          item.product_title.includes('Carabiners - Build A Drip') ||
          item.product_title.includes('Charm - Build A Drip') ||
          (item.properties && item.properties['Bundle Group'])
        );
      };

      // Separate regular items from build-a-drip items
      const regularItems = cart.items.filter((item) => !isBuildADripItem(item));
      const buildADripItems = cart.items.filter((item) => isBuildADripItem(item));

      // Group build-a-drip items by Bundle Group
      const bundleGroups = {};
      buildADripItems.forEach((item) => {
        const bundleId =
          item.properties && item.properties['Bundle Group'] ? item.properties['Bundle Group'] : 'legacy';
        if (!bundleGroups[bundleId]) {
          bundleGroups[bundleId] = {
            beads: null,
            carabiner: null,
            charm: null,
          };
        }

        const component = item.properties && item.properties['Component'] ? item.properties['Component'] : 'legacy';
        if (component === 'Beads') {
          bundleGroups[bundleId].beads = item;
        } else if (component === 'Carabiner') {
          bundleGroups[bundleId].carabiner = item;
        } else if (component === 'Charm') {
          bundleGroups[bundleId].charm = item;
        } else {
          // Legacy items without Bundle Group - treat as individual items
          bundleGroups[bundleId][component.toLowerCase()] = item;
        }
      });

      // Create items HTML with proper grouping
      let itemsHTML = '';

      // Render regular items first
      regularItems.forEach((item) => {
        itemsHTML += createItemHTML(item, false);
      });

      // Render build-a-drip bundles
      Object.values(bundleGroups).forEach((bundle) => {
        if (bundle.beads) {
          // Render the beads item as parent
          itemsHTML += createItemHTML(bundle.beads, false);

          // Render carabiner as child if it exists
          if (bundle.carabiner) {
            itemsHTML += createItemHTML(bundle.carabiner, true);
          }

          // Render charm as child if it exists
          if (bundle.charm) {
            itemsHTML += createItemHTML(bundle.charm, true);
          }
        } else {
          // Legacy items without beads - render individually
          Object.values(bundle).forEach((item) => {
            if (item) {
              itemsHTML += createItemHTML(item, false);
            }
          });
        }
      });

      container.innerHTML = itemsHTML;
    } else {
      container.innerHTML = `
        <div class="text-center py-8">
          <p class="text-[#f9f2ff] text-lg font-manrope">Your cart is empty</p>
        </div>
      `;
    }
  }

  // Function to update cart summary
  function updateCartSummary(cart) {
    // Target the cart summary in both desktop and mobile dropdowns
    const cartSummaries = document.querySelectorAll('.cart-summary');
    console.log('Updating cart summary, found', cartSummaries.length, 'cart summaries');
    console.log('Cart data:', cart);

    // If no cart summary elements exist, create them in the cart dropdowns
    if (cartSummaries.length === 0) {
      const cartDropdowns = document.querySelectorAll('#cart-dropdown-content, #mobile-cart-dropdown-content');
      cartDropdowns.forEach((dropdown) => {
        // Find the container where cart summary should be inserted
        const container = dropdown.querySelector('.flex.flex-col.h-full.mx-auto');
        if (container) {
          // Create cart summary element
          const cartSummaryElement = document.createElement('div');
          cartSummaryElement.className = 'cart-summary';
          container.appendChild(cartSummaryElement);
          console.log('Created cart summary element in dropdown');
        }
      });
    }

    // Now update all cart summary elements (including newly created ones)
    const updatedCartSummaries = document.querySelectorAll('.cart-summary');
    console.log('Updating', updatedCartSummaries.length, 'cart summaries');

    updatedCartSummaries.forEach((cartSummary) => {
      if (cart.item_count > 0) {
        const subtotalText =
          cart.item_count === 1 ? `Subtotal (${cart.item_count} item)` : `Subtotal (${cart.item_count} items)`;

        cartSummary.innerHTML = `
          <div class="space-y-4">
            <div class="flex justify-between items-center">
              <span class="text-white text-base font-manrope">${subtotalText}</span>
              <span class="text-white text-base font-manrope">${formatMoney(cart.total_price)}</span>
            </div>
            <a href="/checkout" class="btn btn--primary w-full">Checkout</a>
          </div>
        `;
        console.log('Updated cart summary with', cart.item_count, 'items, total:', formatMoney(cart.total_price));
      } else {
        cartSummary.innerHTML = '';
        console.log('Cleared cart summary - empty cart');
      }
    });
  }

  // Function to update free shipping progress
  function updateFreeShippingProgress(cart) {
    // Look for free shipping progress elements in all possible locations
    const freeShippingProgressElements = document.querySelectorAll('.free-shipping-progress');
    console.log('Updating free shipping progress, found', freeShippingProgressElements.length, 'elements');

    const threshold = 25000; // $250 in cents
    const currentTotal = cart.total_price;
    const progressPercentage = Math.min(100, (currentTotal / threshold) * 100);

    console.log('Free shipping progress:', {
      currentTotal: currentTotal,
      threshold: threshold,
      progressPercentage: progressPercentage,
      remaining: Math.max(0, threshold - currentTotal),
    });

    if (freeShippingProgressElements.length > 0) {
      // Update all existing free shipping progress elements
      freeShippingProgressElements.forEach((element, index) => {
        element.innerHTML = `
          <p class="text-center font-offbit leading-none uppercase mb-4">Free shipping when you spend $250</p>
          <div class="relative">
            <div class="bg-brand-dark-2 h-[13px] rounded-[10px] w-full"></div>
            <div
              class="bg-gold h-[13px] rounded-[10px] absolute top-0 left-0 transition-all duration-300"
              style="width: ${progressPercentage}%"
            ></div>
          </div>
        `;
        console.log(`Updated free shipping progress bar ${index + 1} to`, progressPercentage + '%');
      });
    } else {
      console.log('No free shipping progress elements found - this is normal on product pages');
    }

    // Also try to update any progress bars that might be in cart dropdowns that aren't rendered yet
    // This ensures that when the dropdown is opened, it will have the correct progress
    const cartDropdowns = document.querySelectorAll('#cart-dropdown-content, #mobile-cart-dropdown-content');
    cartDropdowns.forEach((dropdown, index) => {
      const existingProgress = dropdown.querySelector('.free-shipping-progress');
      if (existingProgress) {
        existingProgress.innerHTML = `
          <p class="text-center font-offbit leading-none uppercase mb-4">Free shipping when you spend $250</p>
          <div class="relative">
            <div class="bg-brand-dark-2 h-[13px] rounded-[10px] w-full"></div>
            <div
              class="bg-gold h-[13px] rounded-[10px] absolute top-0 left-0 transition-all duration-300"
              style="width: ${progressPercentage}%"
            ></div>
          </div>
        `;
        console.log(`Updated cart dropdown ${index + 1} free shipping progress to`, progressPercentage + '%');
      }
    });
  }

  // Helper function to format money
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(cents / 100);
  }

  // Validate cart for parent-child relationships
  function validateCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        // Get all beads and carabiner items
        const beadsItems = cart.items.filter((item) => item.product_title.includes('Beads - Build A Drip'));
        const carabinerItems = cart.items.filter((item) => item.product_title.includes('Carabiners - Build A Drip'));

        // If there are more carabiners than beads, remove the extra ones
        if (carabinerItems.length > beadsItems.length) {
          console.log('Removing orphaned carabiners from cart');
          const carabinersToRemove = carabinerItems.slice(beadsItems.length);

          return Promise.all(
            carabinersToRemove.map((carabiner) =>
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                  id: carabiner.key,
                  quantity: 0,
                }),
              }).then((response) => response.json())
            )
          ).then(() => {
            // Update cart UI after removal
            window.updateCartUI();
          });
        }
      })
      .catch((error) => {
        console.error('Error validating cart:', error);
      });
  }

  // Run validation on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCart);
  } else {
    validateCart();
  }

  // Make validation function globally available for manual calls
  window.validateCart = validateCart;

  // Event delegation for cart remove buttons
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-remove-btn')) {
      e.preventDefault();
      const button = e.target.closest('.cart-remove-btn');
      const itemKey = button.getAttribute('data-item-key');
      console.log('Removing item:', itemKey);
      removeCartItem(itemKey);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Note: addToCart and updateCartUI functions are now globally available from header.liquid

  // Add to cart with quantity from counter
  window.addToCartWithQuantity = function () {
    const variantInput = document.getElementById('variant-input');
    const quantityInput = document.querySelector('input[name="quantity"]');

    // Get variant ID
    let variantId = null;

    // First try: use variant input (for multi-variant products)
    if (variantInput && variantInput.value) {
      variantId = variantInput.value;
    }
    // Second try: get from variant buttons (for multi-variant products)
    else {
      const selectedVariantButton = document.querySelector('.variant-button.selected');
      if (selectedVariantButton) {
        variantId = selectedVariantButton.getAttribute('data-variant-id');
      }
      // Third try: get first available variant button
      else {
        const firstVariantButton = document.querySelector('.variant-button:not([disabled])');
        if (firstVariantButton) {
          variantId = firstVariantButton.getAttribute('data-variant-id');
        }
      }
    }

    // For single variant products, get variant ID from the form's hidden input or product data
    if (!variantId) {
      // Try to get from single variant input first
      const singleVariantInput = document.getElementById('single-variant-input');
      if (singleVariantInput && singleVariantInput.value) {
        variantId = singleVariantInput.value;
      }
      // Try to get from form's hidden input (if it exists)
      else {
        const formVariantInput = document.querySelector('input[name="id"]');
        if (formVariantInput && formVariantInput.value) {
          variantId = formVariantInput.value;
        }
        // Last resort: use the product's first available variant ID from Liquid
        else {
          // This will be set by Liquid in the template
          const defaultVariantId = window.defaultVariantId || null;
          if (defaultVariantId && defaultVariantId !== '') {
            variantId = defaultVariantId;
          }
        }
      }
    }

    // Get quantity - use input value if available, otherwise default to 1
    let quantity = 1;
    if (quantityInput && quantityInput.value) {
      quantity = parseInt(quantityInput.value) || 1;
    }

    if (!variantId) {
      console.error('No variant found. Available elements:', {
        variantInput: !!variantInput,
        variantButtons: document.querySelectorAll('.variant-button').length,
        formInput: !!document.querySelector('input[name="id"]'),
      });
      return;
    }

    // Ensure variantId is a valid number
    const numericVariantId = parseInt(variantId);
    if (isNaN(numericVariantId)) {
      console.error('Invalid variant ID:', variantId, 'Type:', typeof variantId);
      return;
    }

    console.log('Adding to cart:', {
      originalVariantId: variantId,
      numericVariantId: numericVariantId,
      quantity: quantity,
    });
    // Use global addToCart function from header.liquid with retry mechanism
    const tryAddToCart = (retries = 3) => {
      if (typeof window.addToCart === 'function') {
        window.addToCart(numericVariantId, quantity);
      } else if (retries > 0) {
        console.log('Global addToCart function not available, retrying...', retries);
        setTimeout(() => tryAddToCart(retries - 1), 100);
      } else {
        console.error('Global addToCart function not available after retries, falling back to direct API call');
        // Fallback: direct API call with manual cart update
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: numericVariantId,
            quantity: quantity,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('Product added to cart (fallback):', data);
            // Try to update cart UI if available
            if (typeof window.updateCartUI === 'function') {
              window.updateCartUI();
              // Note: openCartDropdown is already called within updateCartUI
            } else {
              // Last resort: reload page
              window.location.reload();
            }
          })
          .catch((error) => {
            console.error('Error adding product to cart (fallback):', error);
          });
      }
    };

    tryAddToCart();
  };

  // Function to update carousel videos based on selected variant
  function updateCarouselForVariant(variantId) {
    const variantMetafields = window.variantMetafields || {};
    const variantData = variantMetafields.variants?.[variantId];
    const productData = variantMetafields.product || {};

    if (!variantData && !productData) {
      return;
    }

    const carousel = document.querySelector('.product-carousel');
    if (!carousel) {
      return;
    }

    // Get new video URLs with fallback: variant first, then product
    const animatedVideo =
      variantData?.animated_video && variantData.animated_video !== ''
        ? variantData.animated_video
        : productData.animated_video;
    const animatedVideoMobile =
      variantData?.animated_video_mobile && variantData.animated_video_mobile !== ''
        ? variantData.animated_video_mobile
        : productData.animated_video_mobile;

    // Helper function to update video source
    function updateVideoSource(videoElement, newSrcWebm, newSrcMov) {
      if (!videoElement) return;

      const currentSource = videoElement.querySelector('source');
      const isSafari = (function () {
        var ua = navigator.userAgent || '';
        var vendor = navigator.vendor || '';
        var isAppleVendor = vendor.indexOf('Apple') > -1;
        var isSafariUA = /safari/i.test(ua) && !/chrome|crios|chromium|edg/i.test(ua);
        return isAppleVendor || isSafariUA;
      })();

      const deviceType = videoElement.closest('.carousel-video-wrapper')?.dataset.device;
      const pickMov = deviceType === 'desktop' ? isSafari : true; // mobile prefers MOV when present

      const chosenInput = pickMov && newSrcMov ? newSrcMov : newSrcWebm || newSrcMov;

      if (chosenInput && chosenInput !== '') {
        const fileUrl = chosenInput.includes('cdn.shopify.com') ? chosenInput : `https://cdn.shopify.com${chosenInput}`;

        if (currentSource) {
          currentSource.src = fileUrl;
          currentSource.type = pickMov && newSrcMov ? 'video/quicktime; codecs=hvc1' : 'video/webm; codecs=vp9, opus';
        } else {
          const source = document.createElement('source');
          source.src = fileUrl;
          source.type = pickMov && newSrcMov ? 'video/quicktime; codecs=hvc1' : 'video/webm; codecs=vp9, opus';
          videoElement.appendChild(source);
        }

        videoElement.load();
        if (videoElement.closest('.active')) {
          videoElement.play();
        }
      }
    }

    // Update desktop video
    const desktopVideo = carousel.querySelector('.carousel-video-desktop .carousel-main-video');
    const desktopThumbVideo = carousel.querySelector('.carousel-thumb-desktop .carousel-thumb-video');

    if (animatedVideo && animatedVideo !== '') {
      updateVideoSource(desktopVideo, animatedVideo, animatedVideoMobile);
      if (desktopThumbVideo) {
        updateVideoSource(desktopThumbVideo, animatedVideo, animatedVideoMobile);
      }
    }

    // Update mobile video
    const mobileVideo = carousel.querySelector('.carousel-video-mobile .carousel-main-video');
    const mobileThumbVideo = carousel.querySelector('.carousel-thumb-mobile .carousel-thumb-video');

    if (animatedVideoMobile && animatedVideoMobile !== '') {
      updateVideoSource(mobileVideo, null, animatedVideoMobile);
      if (mobileThumbVideo) {
        updateVideoSource(mobileThumbVideo, null, animatedVideoMobile);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const variantButtons = document.querySelectorAll('.variant-button');
    const variantInput = document.getElementById('variant-input');
    const priceElement = document.querySelector('h3');
    const qtyInput = document.querySelector('input[name="quantity"]');
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const customizeBtn = document.getElementById('customize-btn');

    function setAddToCartDisabled(disabled, reason) {
      if (!addToCartBtn) return;
      addToCartBtn.disabled = !!disabled;
      if (disabled) {
        addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
        if (reason) addToCartBtn.title = reason;
        else addToCartBtn.removeAttribute('title');
        addToCartBtn.setAttribute('aria-disabled', 'true');
      } else {
        addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        addToCartBtn.removeAttribute('aria-disabled');
        addToCartBtn.removeAttribute('title');
      }
    }

    function setCustomizeDisabled(disabled, reason) {
      if (!customizeBtn) return;
      const canCustomize = customizeBtn.getAttribute('data-can-customize') === 'true';
      // Never enable if merchant-configured as not customizable
      const effectiveDisabled = disabled || !canCustomize;
      customizeBtn.disabled = !!effectiveDisabled;
      if (effectiveDisabled) {
        customizeBtn.classList.add('opacity-50', 'cursor-not-allowed');
        if (reason) customizeBtn.title = reason;
        else customizeBtn.removeAttribute('title');
        customizeBtn.setAttribute('aria-disabled', 'true');
      } else {
        customizeBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        customizeBtn.removeAttribute('aria-disabled');
        customizeBtn.removeAttribute('title');
      }
    }

    function setCounterDisabled(disabled) {
      const counterContainer = document.querySelector('.counter-container');
      if (!counterContainer) return;

      const plusBtn = counterContainer.querySelector('.counter-btn--plus');
      const minusBtn = counterContainer.querySelector('.counter-btn--minus');
      const input = counterContainer.querySelector('.counter-input');

      if (disabled) {
        counterContainer.setAttribute('data-prop-disabled', 'true');
        if (plusBtn) plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
      } else {
        counterContainer.removeAttribute('data-prop-disabled');
        // Update button states based on current value and min/max
        if (input && plusBtn && minusBtn) {
          const min = parseInt(input.getAttribute('min')) || 1;
          const max = parseInt(input.getAttribute('max')) || 99;
          const value = parseInt(input.value) || min;
          // Only disable based on min/max, not prop-disabled
          minusBtn.disabled = value <= min;
          plusBtn.disabled = value >= max;
        }
      }
    }

    // Log initial current variant and quantity context with all attributes
    const initialVariantId = (variantInput && variantInput.value) || window.defaultVariantId || null;
    if (initialVariantId) {
      const v = (window.productVariants && window.productVariants[initialVariantId]) || null;
      const initialButton = document.querySelector(`.variant-button[data-variant-id="${initialVariantId}"]`);
      const buttonData = initialButton
        ? {
            available: initialButton.getAttribute('data-variant-available'),
            inventory_quantity: initialButton.getAttribute('data-variant-inventory-quantity'),
            inventory_management: initialButton.getAttribute('data-variant-inventory-management'),
            inventory_policy: initialButton.getAttribute('data-variant-inventory-policy'),
          }
        : null;
      console.log('[Product] Current variant (initial):', {
        variantId: initialVariantId,
        variant: v,
        buttonData: buttonData,
        quantity: qtyInput ? qtyInput.value : null,
        min: qtyInput ? qtyInput.min : null,
        max: qtyInput ? qtyInput.max : null,
        stockAttr: qtyInput ? qtyInput.getAttribute('stock') : null,
        availability_analysis: v
          ? {
              available_property: v.available,
              inventory_quantity: v.inventory_quantity,
              inventory_management: v.inventory_management,
              inventory_policy: v.inventory_policy,
              can_purchase:
                v.available &&
                (v.inventory_quantity > 0 || v.inventory_policy === 'continue' || !v.inventory_management),
            }
          : null,
      });
      if (v) {
        setAddToCartDisabled(!v.available, v && !v.available ? 'Out of stock' : '');
        setCustomizeDisabled(!v.available, v && !v.available ? 'Out of stock' : '');
        setCounterDisabled(!v.available);
      }
    }

    variantButtons.forEach((button) => {
      button.addEventListener('click', function () {
        if (this.disabled) return;

        // Remove selected class from all buttons
        variantButtons.forEach((btn) => btn.classList.remove('selected'));

        // Add selected class to clicked button
        this.classList.add('selected');

        // Update hidden input value
        const variantId = this.getAttribute('data-variant-id');
        variantInput.value = variantId;

        // Log variant change and quantity context with all attributes
        const v = (window.productVariants && window.productVariants[variantId]) || null;
        const buttonData = {
          available: this.getAttribute('data-variant-available'),
          inventory_quantity: this.getAttribute('data-variant-inventory-quantity'),
          inventory_management: this.getAttribute('data-variant-inventory-management'),
          inventory_policy: this.getAttribute('data-variant-inventory-policy'),
        };
        console.log('[Product] Current variant (changed):', {
          variantId,
          variant: v,
          buttonData: buttonData,
          quantity: qtyInput ? qtyInput.value : null,
          min: qtyInput ? qtyInput.min : null,
          max: qtyInput ? qtyInput.max : null,
          stockAttr: qtyInput ? qtyInput.getAttribute('stock') : null,
          availability_analysis: v
            ? {
                available_property: v.available,
                inventory_quantity: v.inventory_quantity,
                inventory_management: v.inventory_management,
                inventory_policy: v.inventory_policy,
                can_purchase:
                  v.available &&
                  (v.inventory_quantity > 0 || v.inventory_policy === 'continue' || !v.inventory_management),
              }
            : null,
        });
        if (v) {
          setAddToCartDisabled(!v.available, v && !v.available ? 'Out of stock' : '');
          setCustomizeDisabled(!v.available, v && !v.available ? 'Out of stock' : '');
          setCounterDisabled(!v.available);
        }

        // Update price if element exists
        const newPrice = this.getAttribute('data-variant-price');
        if (priceElement && newPrice) {
          priceElement.textContent = newPrice;
        }

        // Update carousel videos if variant has different video metafields
        updateCarouselForVariant(variantId);

        // Filter carousel images to show only images for selected variant
        if (typeof window.filterProductCarouselImages === 'function') {
          window.filterProductCarouselImages(variantId);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Search Filters Functionality
  document.addEventListener('DOMContentLoaded', function () {
    const filterForm = document.querySelector('[data-collection-filters]');
    const sortInputs = document.querySelectorAll('input[name="sort_by"]');
    const sortOptions = document.querySelectorAll('.sort-option');
    const filterInputs = document.querySelectorAll('input[type="checkbox"]');

    // Handle sort option clicks
    sortOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const value = this.getAttribute('data-value');
        const input = document.querySelector(`input[name="sort_by"][value="${value}"]`);
        if (input) {
          input.checked = true;
          updateSortStyling();
          const url = new URL(window.location);
          url.searchParams.set('sort_by', value);
          window.location.href = url.toString();
        }
      });
    });

    // Handle filter changes
    filterInputs.forEach((input) => {
      input.addEventListener('change', function () {
        applyFilters();
      });
    });

    // Apply filters function
    function applyFilters() {
      const url = new URL(window.location);
      const formData = new FormData(filterForm);

      // Clear existing filter params
      const paramsToRemove = [];
      for (const [key] of url.searchParams) {
        if (key.startsWith('filter.')) {
          paramsToRemove.push(key);
        }
      }
      paramsToRemove.forEach((param) => url.searchParams.delete(param));

      // Add new filter params
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('filter.') && value) {
          url.searchParams.set(key, value);
        }
      }

      window.location.href = url.toString();
    }

    // Clear filters function
    window.clearFilters = function () {
      const url = new URL(window.location);
      const paramsToRemove = [];
      for (const [key] of url.searchParams) {
        if (key.startsWith('filter.') || key === 'sort_by') {
          paramsToRemove.push(key);
        }
      }
      paramsToRemove.forEach((param) => url.searchParams.delete(param));
      window.location.href = url.toString();
    };

    // Toggle mobile filters function
    window.toggleMobileFilters = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const mobileFilters = document.getElementById('mobile-filters');
      const toggleButton = document.getElementById('mobile-filter-toggle');

      if (mobileFilters && toggleButton) {
        if (mobileFilters.classList.contains('mobile-filters-hidden')) {
          // Show filters
          mobileFilters.classList.remove('mobile-filters-hidden');
          mobileFilters.classList.add('mobile-filters-visible');
          toggleButton.textContent = 'Hide filters';
        } else {
          // Hide filters
          mobileFilters.classList.remove('mobile-filters-visible');
          mobileFilters.classList.add('mobile-filters-hidden');
          toggleButton.textContent = 'Show filters';
        }
      }

      return false;
    };

    // Update sort option styling
    function updateSortStyling() {
      sortOptions.forEach((option) => {
        option.classList.remove('selected');
        const value = option.getAttribute('data-value');
        const input = document.querySelector(`input[name="sort_by"][value="${value}"]`);
        if (input && input.checked) {
          option.classList.add('selected');
        }
      });
    }

    // Set current sort value and styling
    const currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'relevance';
    const currentSortInput = document.querySelector(`input[name="sort_by"][value="${currentSort}"]`);
    if (currentSortInput) {
      currentSortInput.checked = true;
    }
    updateSortStyling();

    // Set current filter values
    const urlParams = new URLSearchParams(window.location.search);
    filterInputs.forEach((input) => {
      const paramName = input.name;
      const paramValue = input.value;
      if (urlParams.get(paramName) === paramValue) {
        input.checked = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Testimonials data array
    const testimonials = [
      {
        text: "I love Spicy Dan!!!! I have two necklaces and I'm wearing them constantly. There are a lot of beaded necklaces on the market today, but these are like no other! The quality is unmatched and you can feel the love put into each piece. Needless to say I look forward to expanding my collection even more. I love the fun new drops & you can just tell there is so much work behind all this. Spicy girl for life!!!!",
        author: 'Maddie B',
      },
      {
        text: 'My most complimented jewelry hands down.',
        author: 'Ali T',
      },
      {
        text: 'My favorite way to spice up an outfit and my new go-to birthday present for friends!',
        author: 'Izzy K',
      },
      {
        text: "Absolutely in love with my SpicyDan necklace! The amount of compliments I get when I wear it is insane! Each one is so unique and the quality is unmatched! I'm also obsessed with the carabiner clasp. I never have to worry about my necklace turning and being backwards! Can't recommend enough 10000/10!",
        author: 'Courtney F',
      },
      {
        text: "I just got my spicy Dan necklace and I have barely taken it off since!!!! I have gotten so many compliments on it from my friends and it is easily my new favorite necklace!!! It goes with anything and makes every outfit feel like so much fun, it's safe to say I am obsessed with spicy Dan",
        author: 'Ashley T',
      },
      {
        text: 'I get so many compliments on my spicy dan necklace. It SPICES UP every outfit I wear it with!!!!',
        author: 'Sammi F',
      },
      {
        text: 'My necklaces I have bought from Spicy Dan bring me joy on dark days. They remind me to find the light and that joy is an act of resistance.',
        author: 'Vanessa',
      },
      {
        text: 'My favorite necklace to wear for any occasion! Can dress it up or down. I always get so many compliments whenever I wear it!!',
        author: 'Rachel L',
      },
      {
        text: 'Have ordered 3 spicy Dan necklaces!! Two for myself and one for my mom - they are effortlessly stylish, elevates every outfit, and always get compliments!! #spicydanfan',
        author: 'Paige M',
      },
      {
        text: 'Spicy Dan is home of the hot cool girl necklace !!!!!!!',
        author: 'Eli R',
      },
      {
        text: 'Spicy Dan is the coolest thing to happen since fetch',
        author: 'Nicole Z',
      },
      {
        text: 'I have built my own Spicy Dan necklace twice now! It was in quick succession because I got my first and loved it so much I had to go right back for another. These are the perfect necklace for layering or as a stand alone piece. I love that you can choose your own color palate and the materials are such high quality! Excited to keep building my collection',
        author: 'Mary F',
      },
      {
        text: 'Best company ever. Coolest and most unique pieces and I will be a loyal customer forever!!!!',
        author: 'Kelsey H',
      },
      {
        text: "It's the most compliments I get when I wear my Spicy Dan",
        author: 'Katherine G',
      },
    ];

    const testimonialCarousel = document.querySelector('.testimonial-carousel');
    if (!testimonialCarousel) return;

    const contentContainer = document.getElementById('testimonial-content');
    const dotsContainer = document.getElementById('testimonial-dots');

    let currentSlide = 0;
    let autoPlayInterval;
    let restartTimeout;
    let isTransitioning = false;

    // Function to create testimonial HTML
    function createTestimonialHTML(testimonial) {
      return `
        <p class="text-center !text-[16px] lg:!text-[24px] text-bg leading-tight font-offbit-bold">
          "${testimonial.text}"
        </p>
        <div class="text-center lg:mb-10 mb-0 mt-3">
          <p class="text-bg text-lg leading-tight uppercase font-offbit-bold">- ${testimonial.author}</p>
        </div>
      `;
    }

    // Function to create dot HTML
    function createDot(index) {
      return `
        <button
          class="testimonial-dot ${index === 0 ? 'active' : ''}"
          data-slide="${index}"
        ></button>
      `;
    }

    // Function to render dots
    function renderDots() {
      dotsContainer.innerHTML = testimonials.map((_, index) => createDot(index)).join('');
    }

    // Function to show a specific slide with fade transition
    function showSlide(index) {
      if (isTransitioning || index === currentSlide) return;

      isTransitioning = true;

      // Remove any existing fade classes
      contentContainer.classList.remove('fade-out', 'fade-in');

      // Force a reflow to ensure classes are applied
      contentContainer.offsetHeight;

      // Fade out current content
      contentContainer.classList.add('fade-out');

      setTimeout(() => {
        // Update content while invisible
        contentContainer.innerHTML = createTestimonialHTML(testimonials[index]);

        // Update dots
        const dots = testimonialCarousel.querySelectorAll('.testimonial-dot');
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });

        // Force a reflow to ensure content is rendered
        contentContainer.offsetHeight;

        // Remove fade-out and add fade-in
        contentContainer.classList.remove('fade-out');
        contentContainer.classList.add('fade-in');

        currentSlide = index;
        isTransitioning = false;
      }, 800); // Full transition duration to ensure complete fade out
    }

    // Function to go to next slide
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % testimonials.length;
      showSlide(nextIndex);
    }

    // Function to start auto-play
    function startAutoPlay() {
      // Clear any existing interval first
      stopAutoPlay();
      autoPlayInterval = setInterval(nextSlide, 6000); // Change slide every 6 seconds to account for transition
    }

    // Function to stop auto-play
    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
      if (restartTimeout) {
        clearTimeout(restartTimeout);
        restartTimeout = null;
      }
    }

    // Function to add event listeners
    function addEventListeners() {
      // Add click event listeners to dots
      dotsContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('testimonial-dot')) {
          e.preventDefault();
          const index = parseInt(e.target.getAttribute('data-slide'));
          showSlide(index);
          stopAutoPlay();
          // Restart auto-play after a delay to give user time to read
          restartTimeout = setTimeout(() => {
            startAutoPlay();
          }, 10000);
        }
      });

      // Pause auto-play on hover
      testimonialCarousel.addEventListener('mouseenter', stopAutoPlay);
      testimonialCarousel.addEventListener('mouseleave', startAutoPlay);

      // Pause auto-play when page is not visible (tab switching)
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoPlay();
        } else {
          startAutoPlay();
        }
      });
    }

    // Initialize the carousel
    function initCarousel() {
      // Render initial testimonial
      contentContainer.innerHTML = createTestimonialHTML(testimonials[0]);

      // Force a reflow to ensure content is rendered
      contentContainer.offsetHeight;

      // Add fade-in class
      contentContainer.classList.add('fade-in');

      // Render dots
      renderDots();

      // Add event listeners
      addEventListeners();

      // Start auto-play
      startAutoPlay();
    }

    // Start the carousel
    initCarousel();
  });

  } catch(e) { console.error(e); }
})();
})();
